export const es = {
  CANONICAL_LOCALE: "es-ES",

  "general.send": "Enviar",
  "general.cancel": "Cancelar",
  "general.apply": "Aplicar",
  "general.name": "Nombre",
  "general.privacy": "Privacidad",
  "general.recipients": "Participantes",
  "general.message": "Mensaje",
  "general.toFilter": "Buscar",
  "general.messageSingular": "mensaje",
  "general.messagePlural": "mensajes",
  "general.messageSettings": "Configuraciones de mensaje",

  "date.shortYear": "año",
  "date.shortYears": "años",
  "date.shortMonth": "mes",
  "date.shortMonths": "meses",
  "date.shortDay": "dia",
  "date.shortDays": "dias",
  "date.shortHour": "h",
  "date.shortMinute": "m",
  "date.now": "ahora",
  "date.today": "Hoy",
  "date.yesterday": "Ayer",
  "date.start": "Inicio",
  "date.end": "Final",

  "filter.filterByPeriod": "Filtrar por periodo",
  "filter.filterByProcess": "Filtrar por proceso",
  "filter.filterByRecipient": "Filtrar por participantes",
  "filter.clearFilters": "Limpiar filtros",
  "filter.filterByFlag": "Filtrar por marcador",
  "filter.searchIn": "Buscar en {name}",
  "filter.numberOfactiveMessages": "{number} {sufix}",
  "filter.noMessages": "No hay",
  "filter.allActiveMessages": "Todos los mensajes activos",
  "filter.allActiveMessages.sufixForLabels": "mensajes activos",
  "filter.allActiveMessages.sufixForLabels.singular": "mensaje activo",
  "filter.archivedMessages": "Sólo archivados",
  "filter.archivedMessages.sufixForLabels": "mensajes archivados",
  "filter.archivedMessages.sufixForLabels.singular": "mensaje archivado",
  "filter.allMessages": "Todos los activos y archivados",
  "filter.allMessages.sufixForLabels": "mensajes",
  "filter.allMessages.sufixForLabels.singular": "mensaje",
  "filter.messagesOpenedByMe": "Abiertas por mí",
  "filter.messagesOpenedByMe.sufixForLabels": "mensajes abiertos por mí",
  "filter.messagesOpenedByMe.sufixForLabels.singular": "mensaje abierto por mí",
  "filter.allFinilizedTasks": "Sólo tareas finalizadas",
  "filter.allFinilizedTasks.sufixForLabels": "tareas finalizadas",
  "filter.allFinilizedTasks.sufixForLabels.singular": "tarea finalizada",

  "chat.messages": "Mensajes",
  "chat.settings": "Configuraciones",
  "chat.chatSettings": "Configuraciones de mensajes",
  "chat.userNotFound": "Usuario no encontrado",
  "chat.typeUserName": "Escriba el nombre del usuario",
  "chat.typeMessage": "Escribrir mensaje...",
  "chat.mentionUser": "Mencionar usuario",
  "chat.sendTo": "Enviar para...",
  "chat.optionalTitle": "Titulo (opcional)",
  "chat.archiveMessage": "Archivar mensaje",
  "chat.newMessage": "Nuevo mensaje",
  "chat.newChat": "Nueva conversación",
  "chat.noDescriptionTitle": "{archived} {name} y más {number}",
  "chat.noDescriptionTitleNoOthers": "{archived} {name}",
  "chat.archivedPrefix": "(archivado)",
  "chat.optional": "(opcional) ",
  "chat.noOptionsAvailable": "Ninguna opcione disponible",
  "chat.newMessagesReceived": "Recibió {number} {messagePlural}",
  "chat.noFlag": "Sin marcador",
  "chat.flag": "Marcador",
  "chat.task": "Tarea",
  "chat.flagFinalize": 'Finalizar "{flag}"',
  "chat.finalizedPrefix": "(finalizada)",
  "chat.disabledUser": "inactivo",
  "chat.someUsersInactive":
    "Algunos usuarios están inactivos y no recibirán mensaje",
  "chat.allUsersInactive":
    "Todos los usuarios están inactivos y no recibirán mensajes.",
  "chat.fetchActiveUsersError": "Ocurrió un error al buscar usuarios activos",

  "chat.fileSizeExceeded": "El archivo supera el tamaño admitido de {maxSize}.",
  "chat.fileTypeError": "Formato de archivo no soportado.",
  "chat.fileEmptyError": "Archivo vacío. Seleccione uno válido.",
  "chat.attachmentError": "Error al enviar el archivo. Inténtelo de nuevo.",
  "chat.attachFile": "Adjuntar archivo",
  "chat.viewFile": "Ver archivo",
  "chat.viewError": "Error al visualizar el archivo. Inténtelo de nuevo.",
  "chat.downloadFile": "Descargar archivo",
  "chat.downloadError": "Error al descargar el archivo. Inténtelo de nuevo.",

  "chat.newChatFileDisabled":
    "Solo podrá enviar archivos después de iniciar la conversación.",
  "chat.cycle": "Ciclo {number}",
  "chat.chatEvents.OPEN_FLOW": "Abrir flujo",
  "chat.chatEvents.OPEN_FORM": "Abrir formulario",
  "message.empty": "Comuníquese com el equipo",
  "message.empty.description":
    "Escriba mensajes para sanar dudas con alguien o con más participantes.",
  "message.error": "Se ha producido un error en el sistema",
  "message.error.description":
    "No se pudo cargar el contenido. Compruebe su conexión, actualice la página o vuelva a intentarlo en un momento.",
  "message.noResults": "No hay mensajes encontrados",
  "message.noResults.description":
    "Modifique los filtros o escriba un nuevo mensaje.",

  "privacy.public": "Pública",
  "privacy.public.description":
    "Se envía a destinatarios seleccionados y puede acceder a él cualquier otro usuario que tenga permiso para acceder al proceso.",
  "privacy.participants": "Participantes",
  "privacy.participants.description":
    "Se envía a destinatarios seleccionados y puede ser accedido por cualquier otro usuario que haya participado en el proceso como responsable de actividades en curso o ya aprobadas.",
  "privacy.private": "Privada",
  "privacy.private.description":
    "Enviado sólo a los destinatarios seleccionados.",

  "settings.inbox": "Caja de entrada de mensajes",
  "settings.sendMessage": "Envío de mensaje",
  "settings.notifications": "Noticaciones",
  "settings.dynamicMessage": "Filtro dinámico de mensajes",
  "settings.dynamicMessage.description":
    "Siempre que navegar o pulsar en un proceso o actividad, los mensajes vinculadas a ellos filtrarán automáticamente. Los filtros se aplicarán normalmente.",
  "settings.alwaysOpenNewMessages": "Siempre abrir nuevos mensajens",
  "settings.alwaysOpenNewMessages.description":
    "Al llegar nuevos mensajes, automáticamente se abrirán en uma área.",
  "settings.pressEnterToSendMessage": "Pulse la tecla enter para enviar",
  "settings.pressEnterToSendMessage.description":
    "El envio de las respuestas en una mensaje serán hechas por la tecla Enter e no más haciendo clic em él botón Enviar. Esa acione no cambia el botón Enviar na creación de nuevas conversaciones.",
  "settings.receiveEmailNotifications":
    "Recibir notificaciones por correo electrónico",
  "settings.receiveEmailNotifications.description":
    "Recibir notificaciones de nuevos mensajes por correo electrónico.",
  "settings.receiveMentionEmailNotifications":
    "Recibir notificaciones de menciones por correo electrónico",
  "settings.receiveMentionEmailNotifications.description":
    "Reciba un correo electrónico cada vez que sea mencionado con @ en un mensaje.",
  "settings.more": "Más configuraciones",
  "settings.notifications.description":
    "Elija entre recibir todas las notificaciones o solo menciones con @",

  "error.reconnectingIn": "Reconectando en {seconds} segundo(s)",
  "error.reconnecting": "Reconectando...",
  "error.connectionLost": "Conexión perdida",

  "tooltip.close": "Cerrar",
  "tooltip.newChat": "Nueva conversación",
  "tooltip.moreActions": "Configuraciones",
  "tooltip.moreOptions": "Más acciones",
  "tooltip.searchFilters": "Filtrar",
  "tooltip.clearFilters": "Limpiar filtros",

  "profiles.manager": "Gerente",
  "profiles.last-approver": "Último_aprobador",
};
